export class LineItemSizeSummary {
	constructor(
		public sizeId: number,
		public name: string,
		public ordered: number,
		public totalCommitted: number,
		public onHand: number,
		public committed: number
	) {}
}

export class LineItemStatusSummary {
	public shippingStatus = "NotShipped";
	public pickTicketType: string | null = null;
	// When the line went into processing (its Processing pick ticket's creation), #1493
	public processingDate: string | null = null;
	public processingHistory: { date: string; description: string }[] = [];

	constructor(
		public lineItemId: number,
		public itemId: number,
		public lineNumber: string,
		public styleCode: string,
		public description: string,
		public stockedItem: boolean,
		public ordered: number,
		public status: string,
		public pickTicketId: string | null,
		public normalPickTicketId: string | null,
		public systemCategoryId: number,
		public shippingDate: string | null,
		public sizes: LineItemSizeSummary[] = [],
		public children: LineItemStatusSummary[] = [],
		public backOrdered: number = 0,
		public dropShip: boolean = false,
		public dropShipShipped: number = 0,
		public trackingNumbers: string[] | null,
		public returnTrackingNumbers: string[] | null = null
	) {
		this.shippingStatus = this.isShipped ? "Shipped" : "NotShipped";
	}

	get hasChildren() {
		return this.children.length > 0;
	}

	get isShipped() {
		return this.status === "Shipped";
	}
}
